"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var dataSource;
        (function (dataSource) {
            var map;
            (function (map) {
                class InitArgs {
                    constructor() {
                        this.userLatLon = appn.emptyString;
                        this.headers = [];
                        this.referringHeaders = {};
                        this.dataSourcesMapEntries = appn.emptyString;
                        this.canUseFilterOptions = false;
                    }
                }
                const _searchString = appn.emptyString;
                const _filter = appn.emptyString;
                const _headerTypes = {};
                const _referringDatasourceColumns = {};
                let _filterOptions = [];
                let _filterIdsInUse = [];
                let _initArgs;
                let _displayedColumn = 'all';
                let _formula;
                let _sortType = '0';
                let _sortTypeColumn;
                let _map;
                let _entrieslayers = [];
                let _pageNum = 1;
                let _totalEntries = 0;
                let _resultsWithoutGPS = 0;
                let _resultsWithGPS = 0;
                let _filterCount = 1;
                let _filterOptionTemplate;
                function init(args) {
                    var _a;
                    _initArgs = args;
                    $('#GoPrevious').hide();
                    $('#GoNext').hide();
                    $('#noGPSResultsWarning').hide();
                    _map = appn.ui.mapInit('map', 0, 0, 11, false);
                    if ($.getUrlVar('dataSourceId') !== appn.emptyString)
                        getEntries();
                    _filterIdsInUse.push(1);
                    _filterOptionTemplate = $('#filterOptionsBox1').clone();
                    if (_initArgs.headers) {
                        const headersArray = _initArgs.headers;
                        for (let i = 0; i < headersArray.length; i++) {
                            const header = headersArray[i];
                            _headerTypes[header.name] = header.dataType;
                            if (header.refId && ((_a = _initArgs.referringHeaders.keys) === null || _a === void 0 ? void 0 : _a.length) > 0 && _initArgs.referringHeaders[header.name].length > 0) {
                                const columns = _initArgs.referringHeaders[header.name];
                                for (let i = 0; i < columns.length; i++)
                                    columns[i] = columns[i].replace(`'`, appn.emptyString).replace(`"`, appn.emptyString);
                                const referringDatasourceColumn = { refId: header.refId, columns: columns };
                                _referringDatasourceColumns[header.name] = referringDatasourceColumn;
                                _headerTypes[header.name] = 'DataSource';
                            }
                        }
                    }
                    addEvents();
                    addDateTimePickerOnInit();
                }
                map.init = init;
                appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function (channel, data) {
                    if (!_map)
                        return;
                    _map.invalidateSize();
                });
                function addEvents() {
                    $('#applyOptions').click(function (e) {
                        e.preventDefault();
                        _pageNum = 1;
                        getEntries();
                    });
                    $('#PageSize').change(function () {
                        _pageNum = 1;
                        getEntries();
                    });
                    $('#GoPrevious').click(function () {
                        _pageNum--;
                        getEntries();
                    });
                    $('#GoNext').click(function () {
                        _pageNum++;
                        getEntries();
                    });
                    $('#addFilter').on('click', function () {
                        addFilter(true);
                    });
                    $(document.body).on('click', '.deleteFilterOption', function (e) {
                        const filterToDelete = $(this).attr('id').replace('deleteFilterOption', '');
                        if (_filterCount <= 1) {
                            $('#filterHeader' + filterToDelete).prop('selectedIndex', 0).change();
                            $('#filterFunction' + filterToDelete).prop('selectedIndex', 0).change();
                            $('#filterBy' + filterToDelete).val('');
                            addDateTimePickerOnInit(filterToDelete);
                            appn.select.init({ selector: '#filterOptions select[id^=filter]' });
                        }
                        else {
                            $('#filterOptionBox' + filterToDelete).remove();
                            const index = _filterIdsInUse.indexOf(parseInt(filterToDelete, undefined));
                            _filterIdsInUse.splice(index, 1);
                            _filterCount--;
                            for (let i = 0; i < _filterCount; i++) {
                                let newTemplate = $('#container-filterOptionTemplate').html();
                                newTemplate = newTemplate.replace(/_id_/g, i + 1);
                                $('#filterOptionBox' + _filterIdsInUse[i]).replaceWith(newTemplate);
                            }
                            _filterIdsInUse = Array.from({ length: _filterCount }, (_, i) => i + 1);
                            appn.select.init({ selector: '#filterOptions select[id^=filter]' });
                        }
                    });
                    $('#applyFilters').click(function (e) {
                        const dataSourceId = $('#DataSourceId').val();
                        _filterOptions = [];
                        for (let i = 0; i < _filterIdsInUse.length; i++) {
                            const filterOption = new Object();
                            filterOption.header = $('#filterHeader' + _filterIdsInUse[i]).val();
                            filterOption.function = $('#filterFunction' + _filterIdsInUse[i]).val();
                            filterOption.by = $('#filterBy' + _filterIdsInUse[i]).val();
                            _filterOptions.push(filterOption);
                        }
                        getEntries();
                        $('#filterOptionsModal').modal('toggle');
                    });
                    $('.btnFilterOptions').click(function (event) {
                        if (_initArgs.canUseFilterOptions)
                            $('#filterOptionsModal').modal('show');
                        else
                            $('#showModalOnClick').modal('show');
                    });
                    $('#filterOptionsModal').on('shown.bs.modal', function () {
                        appn.select.init({ selector: '#filterOptions select[id^=filter]' });
                    });
                    $(document).on('click', '#clearFilters', function (e) {
                        _filterOptions = [];
                        getEntries();
                    });
                    $(document).on('change', '.filterHeader', function (e) {
                        const id = $(this).attr('id').replace('filterHeader', '');
                        const header = String($(this).find(':selected').val());
                        const headerType = _headerTypes[header];
                        switch (headerType) {
                            case 'DateTime':
                                if (!$('#filterBy' + id).parent().hasClass('datetimepicker'))
                                    $('#filterBy' + id).each(function () {
                                        $(`<div class="input-group date datetimepicker">
                                <input class="form-control" id="filterBy${id}" name="filterBy${id}" type="text" value="">
                                <div class="input-group-append input-group-addon">
                                    <button class="input-group-text btn btn-secondary" type="button"><i class="fa fa-calendar fa-xs"></i></button>
                                </div>
                               </div>`)
                                            .insertBefore(this);
                                    }).remove();
                                $('#filterBy' + id).on('click', function () {
                                    appn.ui.dateTimePicker($(this), undefined, 'YYYY-MM-DD HH:mm:ss');
                                }).trigger('click');
                                break;
                            case 'DataSource':
                                if ($('#filterBy' + id).parent().hasClass('datetimepicker')) {
                                    $('#filterBy' + id).parent().each(function () {
                                        $('<select class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '"></select>')
                                            .insertBefore(this);
                                    }).remove();
                                    const columns = _referringDatasourceColumns[header].columns;
                                    for (let i = 0; i < columns.length; i++)
                                        $('#filterBy' + id).append($('<option>', {
                                            value: columns[i],
                                            text: columns[i]
                                        }));
                                }
                                else {
                                    $('#filterBy' + id).each(function () {
                                        $('<select class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '"></select>')
                                            .insertBefore(this);
                                    }).remove();
                                    const columns = _referringDatasourceColumns[header].columns;
                                    for (let i = 0; i < columns.length; i++)
                                        $('#filterBy' + id).append($('<option>', {
                                            value: columns[i],
                                            text: columns[i]
                                        }));
                                }
                                break;
                            default:
                                if ($('#filterBy' + id).parent().hasClass('datetimepicker'))
                                    $('#filterBy' + id).parent().each(function () {
                                        $('<input class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '" type="text">')
                                            .insertBefore(this);
                                    }).remove();
                                else
                                    $('#filterBy' + id).each(function () {
                                        $('<input class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '" type="text">')
                                            .insertBefore(this);
                                    }).remove();
                                break;
                        }
                    });
                }
                function getEntries() {
                    const dataSourceId = $('#DataSourceId').val();
                    const pageSize = $('#PageSize').val();
                    _displayedColumn = $('#DisplayedColumnList').find(':selected').val();
                    _formula = $('#Formula').val();
                    _sortType = $('#SortTypeList').find(':selected').val();
                    _sortTypeColumn = $('#SortTypeColumnList').find(':selected').val();
                    const $form = $('form#appnForm');
                    if ($form.valid())
                        appn.ajax.post({
                            url: _initArgs.dataSourcesMapEntries,
                            data: {
                                dataSourceId: dataSourceId, displayedColumn: _displayedColumn,
                                filter: _filter, formula: _formula, searchString: _searchString,
                                sortType: _sortType, sortTypeColumn: _sortTypeColumn,
                                pageSize: pageSize, pageNum: _pageNum, filterOptions: JSON.stringify(_filterOptions)
                            },
                            done: processResult
                        });
                }
                function addFilter(incrementFilterCount) {
                    if (incrementFilterCount)
                        _filterCount++;
                    _filterIdsInUse.push(_filterCount);
                    appn.select.destroy('#filterOptions select[id^=filter]');
                    let newTemplate = $('#container-filterOptionTemplate').html();
                    newTemplate = newTemplate.replace(/_id_/g, _filterCount).replace('select2-noinit', appn.emptyString);
                    $('#filterOptions').append(newTemplate);
                    addDateTimePickerOnInit(_filterCount.toString());
                    appn.select.init({ selector: '#filterOptions select[id^=filter]' });
                }
                function processResult(data) {
                    removeMarkers();
                    const bounds = [];
                    const userLatLon = _initArgs.userLatLon.split(',');
                    const userLat = userLatLon[0];
                    const userLon = userLatLon[1];
                    let firstEntryLatLng = new L.LatLng(userLat, userLon);
                    let firstPopup;
                    _resultsWithoutGPS = data.iTotalRecordsWithoutGPS;
                    _resultsWithGPS = data.iTotalRecords - data.iTotalRecordsWithoutGPS;
                    const allEntriesll = [];
                    for (let i = 0; i < data.Entries.length; i++) {
                        const lat = data.Entries[i][0];
                        const lon = data.Entries[i][1];
                        const title = data.Entries[i][2];
                        const subTitle = data.Entries[i][3];
                        const imageSrc = data.Entries[i][4];
                        const pinColour = data.Entries[i][5];
                        const pinOutline = (pinColour === 'null') ? 'null' : shadeBlendConvert(0.3, pinColour);
                        if (lat !== 0 && lon !== 0) {
                            const entriesll = new L.LatLng(lat, lon);
                            allEntriesll.push(entriesll);
                            bounds.push([entriesll.lat, entriesll.lng]);
                            let icon = L.divIcon({
                                html: '<div class="appn-mapPin"></div>' +
                                    '<div class="appn-mapShadow"></div>'
                            });
                            if (pinColour !== 'null')
                                icon = L.divIcon({
                                    html: '<div class="appn-mapPin" style="background: ' + pinColour + '; ' +
                                        'border: 2px solid ' + pinOutline + ';' +
                                        '"></div>' +
                                        '<div class="appn-mapShadow" style="background: ' + pinColour + '; ' +
                                        '"></div>'
                                });
                            const entriesmark = new L.Marker(entriesll, { icon: icon });
                            entriesmark.on('click', markerClick);
                            entriesmark.data = data.Entries[i];
                            entriesmark.data.splice(0, 5);
                            _map.addLayer(entriesmark);
                            _entrieslayers.push(entriesmark);
                            let popupText;
                            let popup;
                            if (title !== appn.emptyString || subTitle !== appn.emptyString || imageSrc !== appn.emptyString) {
                                popupText = '<div class="appnMapPopup">';
                                if (title !== appn.emptyString)
                                    popupText += '<h5> ' + title + '</h5>';
                                if (subTitle !== appn.emptyString)
                                    popupText += subTitle + '<br />';
                                if (imageSrc !== appn.emptyString)
                                    popupText += '<img src=' + imageSrc + ' style="display: block; margin: auto; width: 200px;"  />';
                                popupText += `<span class="text-muted leaflet-popup-gpsstring"><i class="fa fa-map-marker"></i> ${lat} ${lon}</span>`;
                                popupText += '</div>';
                                popup = entriesmark.bindPopup(popupText);
                            }
                            if (i === 0) {
                                firstPopup = popup;
                                firstEntryLatLng = entriesll;
                            }
                        }
                    }
                    updateUI(data);
                    if (bounds.length > 0) {
                        _map.fitBounds(bounds);
                        $('#noGPSResultsWarning').hide();
                    }
                    else {
                        _map.setView(firstEntryLatLng, 6);
                        $('#noGPSResultsWarning').show();
                    }
                    const filtersContainer = $('.map-filters');
                    filtersContainer.html(appn.emptyString);
                    appn.sideFilterAndContent.appendShowButton(filtersContainer);
                    const cols = data.ColumnHeaders;
                    const entryDiv = $('#entryData');
                    entryDiv.empty();
                    for (let i = 0; i < cols.length; i++)
                        entryDiv.append('<tr><td><label class="mb-0">' + cols[i] + '</label></td><td class="displayText"></td></tr>');
                }
                function updateUI(data) {
                    const pageSize = $('#PageSize').val();
                    _totalEntries = data.iTotalRecords;
                    let totalText = appn.emptyString;
                    if (_totalEntries > 0) {
                        if (_resultsWithGPS > 0)
                            totalText = T('Found {0} to {1} of {2} rows', (pageSize * _pageNum) - pageSize + 1, Math.min(pageSize * _pageNum, _resultsWithGPS), _resultsWithGPS) + '<br>';
                        if (_resultsWithoutGPS > 0)
                            totalText += '<i>(' + T('Cannot show {0} rows due to missing GPS location', _resultsWithoutGPS) + ')</i>';
                    }
                    else
                        totalText = T('No results found');
                    $('#AppliedFilters').html(data.OtherData[0]);
                    $('#TotalsText').html(totalText);
                    if ((pageSize * _pageNum) < (_totalEntries - _resultsWithoutGPS))
                        $('#GoNext').show();
                    else
                        $('#GoNext').hide();
                    if (_pageNum > 1)
                        $('#GoPrevious').show();
                    else
                        $('#GoPrevious').hide();
                }
                function markerClick(event) {
                    const entryDivs = $('.displayText');
                    for (let i = 1; i < event.target.data.length; i++)
                        $(entryDivs[i - 1]).html(event.target.data[i]);
                }
                function removeMarkers() {
                    for (let i = 0; i < _entrieslayers.length; i++)
                        _map.removeLayer(_entrieslayers[i]);
                    _entrieslayers = [];
                }
                function shadeBlendConvert(p, from, to = appn.emptyString) {
                    if (typeof (p) !== 'number' || p < -1 || p > 1 || typeof (from) !== 'string' || (from[0] !== 'r' && from[0] !== '#') || (typeof (to) !== 'string' && typeof (to) !== 'undefined'))
                        return null;
                    if (!this.sbcRip)
                        this.sbcRip = function (d) {
                            const l = d.length, RGB = new Object();
                            if (l > 9) {
                                d = d.split(',');
                                if (d.length < 3 || d.length > 4)
                                    return null;
                                RGB[0] = i(d[0].slice(4));
                                RGB[1] = i(d[1]);
                                RGB[2] = i(d[2]);
                                RGB[3] = d[3] ? parseFloat(d[3]) : -1;
                            }
                            else {
                                if (l === 8 || l === 6 || l < 4)
                                    return null;
                                if (l < 6)
                                    d = '#' + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (l > 4 ? d[4] + appn.emptyString + d[4] : appn.emptyString);
                                d = i(d.slice(1), 16);
                                RGB[0] = d >> 16 & 255;
                                RGB[1] = d >> 8 & 255;
                                RGB[2] = d & 255;
                                RGB[3] = l === 9 || l === 5 ? r(((d >> 24 & 255) / 255) * 10000) / 10000 : -1;
                            }
                            return RGB;
                        };
                    const i = parseInt;
                    const r = Math.round;
                    let h = from.length > 9;
                    h = typeof (to) === 'string' ? to.length > 9 ? true : to === 'c' ? !h : false : h;
                    const b = p < 0;
                    p = b ? p * -1 : p;
                    to = to && to !== 'c' ? to : b ? '#000000' : '#FFFFFF';
                    const f = this.sbcRip(from);
                    const t = this.sbcRip(to);
                    if (!f || !t)
                        return null;
                    if (h)
                        return 'rgb(' + r((t[0] - f[0]) * p + f[0]) + ',' + r((t[1] - f[1]) * p + f[1]) + ',' + r((t[2] - f[2]) * p + f[2]) + (f[3] < 0 && t[3] < 0 ? ')' : ',' + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 10000) / 10000 : t[3] < 0 ? f[3] : t[3]) + ')');
                    return '#' + (0x100000000 + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 255) : t[3] > -1 ? r(t[3] * 255) : f[3] > -1 ? r(f[3] * 255) : 255) * 0x1000000 + r((t[0] - f[0]) * p + f[0]) * 0x10000 + r((t[1] - f[1]) * p + f[1]) * 0x100 + r((t[2] - f[2]) * p + f[2])).toString(16).slice(f[3] > -1 || t[3] > -1 ? 1 : 3);
                }
                function addDateTimePickerOnInit(id = '1') {
                    const $filterHeader = $('#filterHeader' + id);
                    const header = $filterHeader.find(':selected').val();
                    const headerType = _headerTypes[header];
                    if (headerType === 'DateTime') {
                        if (!$('#filterBy' + id).parent().hasClass('datetimepicker')) {
                            const val = $('#filterBy' + id).val();
                            $('#filterBy' + id).parent().each(function () {
                                $(`<div class="input-group date datetimepicker">
                                <input class="form-control" id="filterBy${id}" name="filterBy${id}" type="text" value="${val}">
                                <div class="input-group-append input-group-addon">
                                    <button class="input-group-text btn btn-secondary" type="button"><i class="fa fa-calendar fa-xs"></i></button>
                                </div>
                               </div>`)
                                    .insertBefore(this);
                            }).remove();
                        }
                        $('#filterBy' + id).on('click', function () {
                            appn.ui.dateTimePicker($(this), undefined, 'YYYY-MM-DD HH:mm:ss');
                        }).trigger('click');
                    }
                }
            })(map = dataSource.map || (dataSource.map = {}));
        })(dataSource = views.dataSource || (views.dataSource = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
